import { memo, useState } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Radio from '@zenbusiness/zui/Radio';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

const CARD_MAILING_ADDRESS_VALUE = {
  PERSONAL_ADDRESS: 'personal_address',
  BUSSINESS_ADDRESS: 'business_address'
};

const CardMailingAddressUIField = ({
  field = { setSaved: () => {}, setLoading: () => {}, key: '' },
  data = {},
  dataChangeHandler = () => {},
  disabled
}) => {
  const {
    businessAddressLine1,
    businessAddressLine2,
    businessAddressCity,
    businessAddressState,
    businessAddressZip,
    cardMailingAddress
  } = data;
  const [selectedValue, setSelectedValue] = useState(cardMailingAddress ?? '');

  const trackCardMailingAddressChangeClick = useClickstreamCallback('buttonPressed');
  const handleDataChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (newValue) {
      field.setLoading();
    }

    dataChangeHandler(
      !!newValue,
      { cardMailingAddress: event.target.value },
      (forceUpdate, { isSave, isError }) => {
        field.setSaved(isSave, isError);
        forceUpdate();
      }
    );

    /**
     * Tracking Details: Tracking added to what your cash flow looks like
     * Question: How many user click what your cash flow looks like Field?
     */
    trackCardMailingAddressChangeClick({
      elementText: newValue,
      elementName: 'banking_collect_info',
      appPageName: 'banking_application'
    });
  };

  return (
    <FormControl disabled={disabled}>
      <RadioGroup
        onChange={handleDataChange}
        sx={{ gap: '24px' }}
        value={selectedValue}
      >
        <FormControlLabel
          control={<Radio aria-label={CARD_MAILING_ADDRESS_VALUE.PERSONAL_ADDRESS} />}
          key={CARD_MAILING_ADDRESS_VALUE.PERSONAL_ADDRESS}
          label={<Text size="xl">Personal Address</Text>}
          value={CARD_MAILING_ADDRESS_VALUE.PERSONAL_ADDRESS}
        />
        <FormControlLabel
          control={<Radio aria-label={CARD_MAILING_ADDRESS_VALUE.BUSSINESS_ADDRESS} />}
          key={CARD_MAILING_ADDRESS_VALUE.BUSSINESS_ADDRESS}
          label={
            <>
              <Text size="xl">Business Address</Text>
              <Text size="xl">{businessAddressLine1}</Text>
              <Text size="xl">{businessAddressLine2}</Text>
              <Text size="xl">{`${businessAddressCity}, ${businessAddressState} ${businessAddressZip}`}</Text>
            </>
          }
          value={CARD_MAILING_ADDRESS_VALUE.BUSSINESS_ADDRESS}
        />
      </RadioGroup>
    </FormControl>
  );
};

CardMailingAddressUIField.propTypes = {
  data: PropTypes.shape({
    businessAddressLine1: PropTypes.string,
    businessAddressLine2: PropTypes.string,
    businessAddressCity: PropTypes.string,
    businessAddressState: PropTypes.string,
    businessAddressZip: PropTypes.string,
    cardMailingAddress: PropTypes.string
  }),
  dataChangeHandler: PropTypes.func,
  field: PropTypes.shape({
    setSaved: PropTypes.func,
    setLoading: PropTypes.func,
    key: PropTypes.string
  }),
  disabled: PropTypes.bool
};

function areEqual(preProp, nextProp) {
  return (
    preProp.field === nextProp.field &&
    preProp.value === nextProp.value &&
    preProp.disabled === nextProp.disabled
  );
}

export default memo(CardMailingAddressUIField, areEqual);
